<script setup>
import { Container, Pagination } from '@codinglabsau/ui'
import moment from 'moment'
import HeadMetaTags from '@/Components/HeadMetaTags.vue'
import Article from '@/Components/Blog/Article.vue'

defineProps({
  articles: Object,
})
</script>

<template>
  <HeadMetaTags
    title="Blog"
    description="Updates and releases for Convict Records."
    :canonical="route('blog.index')"
    :url="route('blog.index')"
  />

  <Container>
    <div class="mx-auto max-w-2xl rounded-lg bg-white">
      <div v-for="article in articles.data" :key="article.id" class="sm:flex">
        <div class="hidden w-36 border-r pr-4 pt-6 text-right text-sm text-gray-500 sm:block">
          <time class="whitespace-nowrap">
            {{ moment(article.created_at).format('D MMM, YYYY') }}
          </time>
        </div>

        <Article :article="article" hide-date class="mb-8 rounded-none border-b pb-8" />
      </div>

      <Pagination :collection="articles"> </Pagination>
    </div>
  </Container>
</template>
